(function () {
	'use strict';

	var scrollspy = require('scrollspy');

	if (window.matchMedia('(min-height: 800px)').matches) {
		scrollspy('.scrollspy', {
			offset: 200
		});
	}
	else {
		scrollspy('.scrollspy', {
			offset: 100
		});
	}
})();
